module.exports = __webpack_public_path__ + "img/icon-member.9182ab11.png";